import DebugSidebarRender from './DebugSidebarRender';

export default DebugSidebarRender;
